import { useMemo } from "react";
import { Badge, Group, Stack, Text } from "@mantine/core";
import type { PendingWorkDetail } from "../../types/pendingWork";

interface Props {
  detail: PendingWorkDetail;
}
const stageQueues: Record<string, string> = {
  "Pending Grossing": "Grossing",
  Grossing: "Grossing",
  "Pending Tissue Processing": "Embedding",
  Embedding: "Embedding",
  "Pending Cutting": "Cutting",
  "Pending Distribution": "Distribution",
  Cutting: "Cutting",
  "Awaiting Scan": "Scanning / case details",
  "Pending Pathologist Review": "Pathologist Review",
  "Pathologist Review": "Pathologist Review",
};
export function PendingWorkDetailItem({ detail }: Props) {
  const context = useMemo(
    () =>
      stageQueues[detail.ownerStatus] ||
      "Locate through case details; owner is outside the active station queues",
    [detail.ownerStatus]
  );
  return (
    <Stack
      gap={3}
      p="xs"
      style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}
    >
      <Group gap="xs">
        <Badge
          color={
            detail.kind === "slide"
              ? "yellow"
              : detail.kind === "sendout"
              ? "blue"
              : "green"
          }
        >
          {detail.kind}
        </Badge>
        <Text size="sm" fw={600}>
          {detail.stage}
        </Text>
        <Text size="xs">
          Owner: {detail.ownerStatus} · Queue context: {context}
        </Text>
      </Group>
      {detail.kind === "slide" && (
        <Text size="sm">
          Specimen {detail.specimen || "—"} · Block {detail.block || "—"} ·
          Stain {detail.stain || "—"} · Slide {detail.slide || "—"}
        </Text>
      )}
      <Text size="sm">{detail.reason}</Text>
    </Stack>
  );
}
